import * as v from "valibot";
import { rpcContract } from "../rpc";

export const TEST_SEND_MAX_RECIPIENTS = 3;
export const TEST_SEND_HOURLY_LIMIT = 10;

export const sendTestCreatorMessageRpcContract = rpcContract({
  name: "send-test-creator-message",
  paramsSchema: v.object({
    title: v.pipe(v.string(), v.minLength(1), v.maxLength(50)),
    content: v.pipe(v.string(), v.minLength(1), v.maxLength(1000)),
    ctaEnabled: v.boolean(),
    ctaText: v.optional(v.nullable(v.pipe(v.string(), v.maxLength(255)))),
    ctaUrl: v.optional(v.nullable(v.string())),
    imageFileId: v.optional(v.nullable(v.pipe(v.string(), v.uuid()))),
    testRecipientEmails: v.pipe(
      v.array(v.pipe(v.string(), v.email())),
      v.minLength(1),
      v.maxLength(TEST_SEND_MAX_RECIPIENTS),
    ),
  }),
  resultSchema: v.object({
    sentTo: v.array(v.string()),
  }),
});

export type SendTestCreatorMessageParams = v.InferOutput<(typeof sendTestCreatorMessageRpcContract)["paramsSchema"]>;
export type SendTestCreatorMessageResult = v.InferOutput<(typeof sendTestCreatorMessageRpcContract)["resultSchema"]>;
